<template class="container">
  <div>
    <div :class="border ? 'grid-container' : 'grid-container borderless'">
      <ul
        :class="{
          setLeftTabs: leftAlign == true,
          tabs__header: leftAlign == false,
          setBackground: background == false
        }"
        :style="[calculateWidth, disabled ? divDisable : '' ]"
      >
        <li
          id="tab"
          :style="{ fontSize: titleSize + 'px' }"
          v-for="(tab, index) in tabs"
          :key="tab.title"
          @click="selectTab(index,tab); selectedTab(index,tab)"
          :class="{
            tab__selected: index == selectedIndex,
            large: largeTabs == true,
            borderless__right: border == false,
          }"
        >
          <img v-if="tab.icon" :src="getImgUrl(tab.icon)" class="icon" />
          {{ tab.title }}
        </li>
      </ul>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "STabs",

  data() {
    return {
      selectedIndex: null, // the index of the selected tab,
      tabs: [], // all of the tabs
      isActive: true, //click directive flag
      divDisable:{
           opacity: 0.65,
           cursor: "not-allowed",
          'pointer-events': 'none',
      },
    };
  },

  props: {
    leftAlign: {
      type: Boolean,
      default: false,
    },
    largeTabs: {
      type: Boolean,
      default: false,
    },
    // title of default to passed as value for defaultOpen
    defaultOpen: {
      type: String,
      required: false,
      default: "",
    },
    titleSize: {
      type: Number,
      default: 16,
    },
    background: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    calculateWidth() {
      // console.log('len: ', this.tabs.length);
      if (this.tabs.length == 1) {
        return { "grid-template-columns": "repeat(1, 1fr)" };
      } else if (this.tabs.length == 2) {
        return { "grid-template-columns": "repeat(2, 1fr)" };
      } else if (this.tabs.length == 3) {
        return { "grid-template-columns": "repeat(3, 1fr)" };
      } else if (this.tabs.length == 4) {
        return { "grid-template-columns": "repeat(4, 1fr)" };
      } else if (this.tabs.length == 5) {
        return { "grid-template-columns": "repeat(5, 1fr)" };
      } else if (this.tabs.length == 6) {
        return { "grid-template-columns": "repeat(6, 1fr)" };
      } else if (this.tabs.length == 7) {
        return { "grid-template-columns": "repeat(7, 1fr)" };
      } else if (this.tabs.length == 8) {
        return { "grid-template-columns": "repeat(8, 1fr)" };
      } else if (this.tabs.length == 9) {
        return { "grid-template-columns": "repeat(9, 1fr)" };
      } else if (this.tabs.length == 10) {
        return { "grid-template-columns": "repeat(10, 1fr)" };
      } else if (this.tabs.length == 11) {
        return { "grid-template-columns": "repeat(11, 1fr)" };
      } else if (this.tabs.length == 12) {
        return { "grid-template-columns": "repeat(12, 1fr)" };
      } else {
        return "";
      }
    },
  },
  mounted() {
    // checking if any tab needs to be opened by default
    if (this.defaultOpen) {
      this.defaultOpenTab();
    } else {
      this.selectTab(null);
    }
  },

  methods: {

    selectTab(i) {
      this.selectedIndex = i;
      // loop over all the tabs
      this.tabs.forEach((tab, index) => {
        tab.isActive = index === i;
        if(tab.isActive == true) {
          this.$emit("selection", tab.title);
        } 
      });
      this.isActive = true;
    },
     selectedTab(i) {
      this.selectedIndex = i;
      // loop over all the tabs
      this.tabs.forEach((tab, index) => {
        tab.isActive = index === i;
        if(tab.isActive == true) {
          this.$emit("selected", tab.title);
        } 
      });
      this.isActive = true;
    },

    getImgUrl(icon) {
      return icon ? require("../assets/" + icon) : "";
    },

    defaultOpenTab() {
      for (let i = 0; i < this.tabs.length; i++) {
        if (this.tabs[i].title == this.defaultOpen) {
          this.selectTab(i);
        }
      }
    },

    // hide: function() {
    //   this.tabs.forEach((tab, index) => {
    //     if(tab.isActive){
    //       tab.isActive = false;
    //       // tab.$parent.selectedIndex = null;
    //     }
    //   });
    // }
  },

  created() {
    this.tabs = this.$children;
  },
};
</script>

<style lang="scss" scoped>
ul.setBackground > li{
  background-color: #FFFFFF !important;
}
.grid-container {
  display: grid;
  grid-template-columns: auto;
  overflow-x: auto;
  /* max-height: 85px; */
  /* height: 96px; */
  overflow-y: hidden;
  border: 2px solid var( --very-light-pink);
}

.borderless {
  border: 0px !important;
}

/**** TODO ****/
/* have to give fix height to use scroll */
/* and fixing tab height does not display tab body */
::-webkit-scrollbar {
  padding-top: 20px;
  height: 5px;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: gray;
  border-radius: 10px;
  height: 5px;
}

ul.tabs__header {
  display: grid;
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  // align-items: center;
}

ul.setLeftTabs {
  display: inline-block;
  grid: auto;
  list-style: none;
  margin: 0;
  padding: 0;
  width: 40%;
}

ul.setLeftTabs > li {
  padding: 16px 40px;
  margin: 0;
  display: inline-block;
  cursor: pointer;
  background-color: var(--white);
  text-align: center;
  justify-self: stretch;
}

ul.setLeftTabs > li.tab__selected {
  background-color: #FFFFFF !important;
  border-bottom: 3px solid var(--primary);
  font-weight: bold;
}

ul.tabs__header > li {
  padding: 16px 40px;
  margin: 0;
  display: inline-block;
  cursor: pointer;
  background-color: var(--white);
  text-align: center;
  justify-self: stretch;
  border-right: solid 1px var(--very-light-pink);
}

.borderless__right{
  border-right: 0px !important;
}

ul.tabs__header  {
  border: none !important;
}

ul.tabs__header > li.tab__selected {
  background-color: #FFFFFF !important;
  border-bottom: 3px solid var(--primary);
  font-weight: bold;
}

#tab {
  display: inline-block;
  color: black;
  padding: 14px;
    font-family: "Roboto !important";
  // font-size: 14px;
  width: auto;
}

.large {
  padding: 20px !important;
}

#tab:hover {
  background-color: #FFFFFF;
}

.icon {
  margin-right: 8px;
  margin-left: -8px;
  width: 16px;
  height: 16px;
}
</style>